module.exports = __webpack_public_path__ + "img/cube-blue.2b035fec.svg";